export enum SidebarPolygonTool {
  medianZones = 'median-zones',
  polygonsInMedianZones = 'polygons-in-median-zones',
  polygonsIntersections = 'polygons-intersections',
  polygonTool = 'polygon-tool',
}
